/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'

export default function DataTableData() {
  const AppService = useAppServices()
  const [List, setList] = useState([])
  const [loader, setloader] = useState(true)

  const formatNotificationMessage = (html = "") => {
    // Keep rich-text links clickable, but strip script/style blocks.
    const sanitizedHtml = html
      .replace(/<script[\s\S]?>[\s\S]?<\/script>/gi, "")
      .replace(/<style[\s\S]?>[\s\S]?<\/style>/gi, "")
      .replace(
        /<a\b(?![^>]\btarget=)([^>]*)>/gi,
        '<a target="_blank" rel="noopener noreferrer"$1>'
      )

    return sanitizedHtml
  }
  const getNotification = async () => {
    const { response, error } = await AppService.notification.get()
    if (response) {
      setList(response.data)
      setloader(false)
    } else {
      setList([])
      setloader(false)
    }
  }
  const onLoad = () => {
    getNotification()
  }
  const handleDelete = async (id) => {
    const { response } = await AppService.notification.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }

  useEffect(onLoad, [])
  return {
    loader: loader,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: 'Title', accessor: 'title' },
        { Header: 'Type', accessor: 'type' },
        { Header: 'Message', accessor: 'message' },
        { Header: 'Action', accessor: 'action' },
      ],

      rows: List.map((data) => ({
        title: data.title,
        type: data.type,
        message: data.message ? (
          <MDBox
            sx={{
              maxWidth: "360px",
              overflowWrap: "anywhere",
              "& a": {
                color: "#1a73e8",
                textDecoration: "underline",
              },
            }}
            dangerouslySetInnerHTML={{ __html: formatNotificationMessage(data.message) }}
          />
        ) : (
          ""
        ),
        action: (
          <MDBox>
            <EditModal
              data={data}
              handleRefresh={onLoad}
            />
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDelete(data._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
  }
}
